import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const ITR_perfiosOnlineBanking_API_CALL = createAsyncThunk(
  'ITR_perfiosOnlineBanking_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({
      type: 'ITR_perfiosOnlineBankreturnUrling_API_CALL/pending',
      payload: {},
    });
    const { perfiosOnlineBankingPayload, successFn, errorFn } = payload;
    const { customerId, Authorization, customerRefNum, returnUrl } =
      perfiosOnlineBankingPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/perfios/onlinetxn',
      payload: {
        customerRefNum,
        returnUrl,
        requestType: 'ITR_ONLINE_TXN',
        journeyType: getState().itrJourney.journeyTypeEnum,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({
          type: 'ITR_perfiosOnlineBanking_API_CALL/fulfilled',
          payload: res,
        });
        if (successFn) successFn(res);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'ITR_perfiosOnlineBanking_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
    });
  }
);

export const ITR_perfiosOnlineBanking_API_CALL_extrareducer = {
  [ITR_perfiosOnlineBanking_API_CALL.pending]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = true;
  },
  [ITR_perfiosOnlineBanking_API_CALL.fulfilled]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = false;
    state.perfiosOnlineBankingAPICall.isSuccess = true;
    state.perfiosOnlineBankingAPICall.isError = false;
    state.perfiosOnlineBankingAPICall.response = action.payload;
  },
  [ITR_perfiosOnlineBanking_API_CALL.rejected]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = false;
    state.perfiosOnlineBankingAPICall.isSuccess = false;
    state.perfiosOnlineBankingAPICall.isError = true;
    state.perfiosOnlineBankingAPICall.response = action.payload;
  },
};
